import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
// import p5 from "p5";
import { gsap } from "gsap";

import 'swiper/css';
import 'swiper/css/effect-fade';

// console.log("home");

const imgs = '/wp-content/themes/lightning-child/assets/images/common/';

const products = [
	{
		name: '低温機器関連',
		image: 'product-img-01.png',
		description: '食品の鮮度保持が不可欠な食品工場やスーパーマーケット、学校給食などの大型厨房、さらには医薬品の品質管理を行う化学・医療施設で使用されます。<br>一定の低温環境を維持するための「冷却」と、それを支える「保管スペース」を構築する現場に導入されます。',
		examples: [
			'冷却ユニット（セパレート・一体型）: 庫内を冷やすための主要設備。',
			'ユニットクーラー: 冷気を循環させ、庫内温度を均一に保つ装置。',
			'恒温恒湿槽: 精密な温度・湿度管理が必要な試験や保管に使用。',
			'冷水機（チラー）: 食品の冷却工程や産業用機械の冷却に使用する循環冷水装置。'
		],
		partners: [
			'ダイキン工業株式会社',
			'日本キヤリア株式会社',
			'パナソニックHVAC＆CCシステムズ株式会社',
			'日立グローバルライフソリューションズ株式会社',
			'株式会社マキシス工業',
			'三菱電機株式会社',
		],
		isPickup: false
		},
		{
		name: '送風機・冷却塔水処理機器関連',
		image: 'product-img-02.png',
		description: '工場内の換気、生産ラインの排気、あるいは大型ビルの空調システムで使用されます。<br>また、生産工程で発生する熱を逃がすための冷却塔（クーリングタワー）や、その水を循環させるポンプ設備、水質を維持して機器の故障を防ぐ水処理が必要な現場に導入されます。',
		examples: [
			'各種送風機（ファン・ブロア）: 有圧換気扇、シロッコファン、ラインファン。',
			'冷却塔（クーリングタワー）: 水冷式空調や生産設備の放熱を担う装置。',
			'各種ポンプ: 陸上ポンプ、水中ポンプ、ラインポンプ（冷温水循環用）。',
			'水処理装置・薬品: スケールや腐食を防ぐための自動薬注装置や水質改善機器。'
		],
		partners: [
			'株式会社荏原製作所',
			'空研工業株式会社',
			'テラル株式会社',
			'日本スピンドル製造株式会社'
		],
		isPickup: false
		},
		{
		name: '配管銅管資材関連',
		image: 'product-img-03.png',
		description: '空調設備や冷凍冷蔵設備の冷媒配管として、室内機と室外機を繋ぐインフラ部分に使用されます。<br>また、給水・給湯配管、油配管、医療用ガス配管など、流体の輸送が必要なあらゆる建築・産業設備の現場で、その耐久性と施工性の高さから広く活用されています。',
		examples: [
			'銅管: 直管、コイル管、断熱材付ペアコイル。',
			'配管継手: エルボ、チーズ、ソケット、フレアナット、メカニカル継手。',
			'配管支持具・関連部材: 配管を固定する金具、化粧カバー、溶接用品（ロウ材・フラックス）。',
			'架台：スプリング防振架台、高置架台、壁掛架台。'
		],
		partners: [
			'アルコニックス・三高株式会社',
			'因幡電機産業株式会社',
			'NJT銅管株式会社',
			'オーケー器材株式会社',
			'日晴金属株式会社',
			'ネミー株式会社'
		],
		isPickup: false
		},
		{
		name: '空調機器関連',
		image: 'product-img-04.png',
		description: '一般住宅から商業施設、オフィスビル、工場、病院、学校まで、あらゆる建物の室内環境を整えるために幅広く使用されています。<br>単なる温度調節だけでなく、用途や設置環境に応じて、湿度管理や空気の清浄化が求められる場所でも不可欠な設備です。',
		examples: [
			'パッケージエアコン: オフィスや店舗向けの一般的な業務用空調。',
			'ビル用マルチエアコン: 1台の室外機で複数の個別制御が可能なシステム。',
			'設備用エアコン: 工場や特殊な生産環境に対応した高出力モデル。',
			'換気・加湿機器: 全熱交換器、業務用加湿器。',
			'エアハンドリングユニット：大空間の空気調和機。',
			'ルームエアコン: 一般住宅や小規模オフィス向けの壁掛け型・床置き型。'
		],
		partners: [
			'ダイキン工業株式会社',
			'日本キヤリア株式会社',
			'パナソニックHVAC＆CCシステムズ株式会社',
			'日立グローバルライフソリューションズ株式会社',
			'三菱重工サーマルシステムズ株式会社',
			'三菱電機株式会社'
		],
		isPickup: false
		},
		{
		name: '自動制御機器関連',
		image: 'product-img-05.png',
		description: '冷凍・冷蔵庫、ショーケース、業務用空調、さらにはカーエアコンなどの内部に組み込まれています。<br>冷媒の流れを精密にコントロールし、機器の性能を最適に保つために、温度・湿度・圧力・流量を自動で検知・調整する「制御の要」として使用されます。',
		examples: [
			'自動制御バルブ: 膨張弁、電磁弁、定圧弁など。',
			'センサー・スイッチ: サーモスタット（温度調節器）、圧力スイッチ、湿度センサ。',
			'回路保護・管理部品: ドライヤー（水分除去）、サイトグラス（冷媒監視窓）。',
			'電子制御コントローラ: 設備全体の運転をプログラムで管理する制御盤やユニット。'
		],
		partners: [
			'株式会社不二工機',
			'アズビル株式会社',
			'CAREL　Japan株式会社',
			'株式会社鷺宮製作所（ダンフォス）',
			'株式会社シマデン'
		],
		isPickup: false
		},
		{
		name: '工場改善関連',
		image: 'product-img-06.png',
		description: '製造現場、物流倉庫、食品加工場など、安全性・生産性・環境負荷の改善が求められるあらゆる現場で使用されます。<br>「より安全に」「より効率よく」「より低コストで」という現場の課題を解決するために導入され、SDGsやカーボンニュートラルへの対応、DX（デジタル化）の推進にも直結する分野です。',
		examples: [
			'ロングファン（搬送ファン・ヘリコプターファン）: 大風量で空気を遠くまで運び、室温のムラを解消する大型送風機。',
			'高性能フィルター: 工場内の空気清浄や防塵、防菌を目的としたフィルター、ソックフィルター。',
			'遮熱・環境改善資材: 屋根への遮熱塗装や、外気の侵入を防ぐシートシャッター。',
			'ミスト冷却システム: 気化熱を利用して工場内を涼しく保つ設備。'
		],
		partners: [
			'株式会社サンロード',
			'ソックフィルター株式会社',
			'ニッシントーア・岩尾株式会社',
			'日本無機株式会社',
			'三菱電機株式会社'
		],
		isPickup: false
		},
		{
		name: '厨房設備・食品工場関連',
		image: 'product-img-07.png',
		description: 'ホテルやレストランの業務用厨房、病院・学校の給食センター、そして食品加工工場などで使用されます。<br>HACCP（ハサップ）に沿った衛生管理が求められる現場において、調理・加工から洗浄、保管までを一貫して支えるための設備です。',
		examples: [
			'加熱調理機器: ガスレンジ、スチームコンベクションオーブン、フライヤー。',
			'洗浄・消毒設備: 業務用食器洗浄機、手指消毒器、電解水生成装置。',
			'作業台・シンク: 衛生的なステンレス製の板金物（特注対応含む）。'
		],
		partners: [
			'だいわ株式会社',
			'パナソニックHVAC＆CCシステムズ株式会社',
			'フクシマガリレイ株式会社',
			'ホシザキ株式会社',
			'SDRS株式会社',
		],
		isPickup: false
		},
		{
		name: '照明関連',
		image: 'product-img-08.png',
		description: 'オフィスや店舗だけでなく、特に工場、倉庫、業務用厨房、冷蔵・冷凍庫といった「特殊環境」で使用されます。<br>省エネ目的のLED化はもちろん、低温環境での即点灯、厨房での耐熱・防湿、あるいは防爆エリアなど、現場の環境条件に合わせた照明設計が求められる場所です。',
		examples: [
			'高天井用LED: 工場や倉庫の広範囲を照らす高出力照明。',
			'特殊環境用照明: 冷蔵・冷凍庫専用LED、耐熱・防雨型照明。',
			'厨房・レンジフード用LED: 油煙や熱に強く、調理の視認性を高める照明。',
			'非常用・誘導灯: 災害時や停電時の安全確保のための照明器具。'
		],
		partners: [
			'東芝ライテック株式会社',
			'パナソニック株式会社',
			'プリンス電機株式会社',
			'三菱電機照明株式会社'
		],
		isPickup: false
		},
		{
		name: '冷熱応用商品<br>（ブラストチラー・急速凍結庫）',
		image: 'product-img-09.png',
		description: '食品工場、セントラルキッチン、飲食店、水産・畜産加工場などで使用されます。<br>調理直後の熱い食材を急速冷却して細菌の繁殖を防ぐ（クックチル）、あるいは鮮度・風味を落とさずに長期保存するために短時間で凍結させるなど、食品の高品質な維持とフードロスの削減を目的とする現場に導入されます。',
		examples: [
			'ブラストチラー・ショックフリーザー: 加熱調理後の食材を急速に冷却・凍結する装置。',
			'急速凍結装置（空気凍結）: 強力な冷風で食品の細胞破壊を防ぎながら凍結する設備。',
			'液体凍結装置（リキッドフリーザー）: アルコール液などを用いて、空気より遥かに速いスピードで凍結させる高精度装置。',
			'真空冷却機: 蒸発熱を利用して、野菜や惣菜を短時間で芯まで冷やす装置。'
		],
		partners: [
			'だいわ株式会社',
			'パナソニックHVAC＆CCシステムズ株式会社',
			'フクシマガリレイ株式会社',
			'ホシザキ株式会社',
			'米田工機株式会社',
			'KEOSマシナリー株式会社',
		],
		isPickup: false
		},
		{
		name: 'プレハブ冷凍冷蔵庫関連',
		image: 'product-img-10.png',
		description: '食品工場、物流センター、スーパーマーケット、飲食店、薬品保管庫などで使用されます。<br>設置スペースや用途に合わせて自由にサイズを設計できるため、大規模な保管から小規模な店舗用まで幅広く対応可能です。また、防熱パネルを組み合わせることで、庫内温度を一定に保ち、鮮度保持や品質管理を徹底する必要がある場所に導入されます。',
		examples: [
			'断熱パネル（防熱パネル）: 優れた断熱性能を持つ壁・天井材。',
			'専用扉: 手動・電動のスライド扉、スイング扉、シートシャッター等。',
			'フロアヒーター: 冷凍庫下の土間凍結（凍上）を防ぐための電熱設備。'
		],
		partners: [
			'ガリレイパネルクリエイト株式会社',
			'株式会社弘洋',
			'株式会社ソーゴ',
			'日軽パネルシステム株式会社',
			'八光冷熱工業株式会社',
			'ホシザキ株式会社'
		],
		isPickup: false
		},
		{
		name: '冷媒関連',
		image: 'product-img-11.png',
		description: '空調機、冷蔵・冷凍設備、ショーケースなどの冷却サイクルを循環する「血液」として使用されます。<br>機器の新設時だけでなく、メンテナンス時の補充や、環境負荷の低い次世代冷媒への切り替え（フロン排出抑制法への対応）が必要な現場において欠かせない資材です。',
		examples: [
			'フルオロカーボン冷媒: 回転ボンベ、NRCボンベ、再生冷媒各種。',
			'回収ボンベ・充填機器: 冷媒の回収や補充に使用する専用ツール。',
			'冷媒漏洩検知器: ガス漏れを早期に発見するための警報装置。',
			'冷凍機油: 圧縮機（コンプレッサー）を潤滑にするための専用オイル。'
		],
		partners: [
			'アオホンケミカルジャパン株式会社',
			'ダイキン工業株式会社',
			'三井・ケマーズフロロプロダクツ株式会社',
			'日本液炭株式会社'
		],
		isPickup: false
		},
		{
		name: '特殊環境機器<br>（防爆、クリーンルームなど）',
		image: 'product-img-12.png',
		description: '化学工場、薬品工場、半導体製造現場、塗装工場など、火災・爆発のリスクがある場所や、極めて高い清浄度が求められる場所で使用されます。<br>一般的な機器では対応できない「引火性ガスの滞留」や「微細なチリの混入」を防ぐための特殊な設計が施された環境です。',
		examples: [
			'防爆型空調機・冷凍機: 火花が出ない設計を施した、危険場所専用の空調設備。',
			'クリーンルーム用空調（FFU）: 高性能フィルタ（HEPA等）を備えたファンフィルタユニット。',
			'エアシャワー: 入室前に衣服の塵埃を高速気流で吹き飛ばす装置。',
			'パスボックス: クリーンルームの清浄度を保ったまま物品を出し入れする窓口。'
		],
		partners: [
			'株式会社ニットー冷熱製作所',
			'日本エアーテック株式会社',
			'日本無機株式会社',
			'株式会社原製作所',
			'株式会社マキシス工業'
		],
		isPickup: false
		}
  ];


  const pickups = [
    {
      name: "エコクーリングエース",
      image: "p-img-04.png",
      description: '2006年の発売以来、室外機向け間接散水冷却システムの先駆者として市場をリードし続けている本製品は、『水の力』を利用して室外機を冷却する、地球と環境にやさしい日本製のシステムです。製造元は、エアコンや自動販売機向け製品の製造を手がけ、世界でも活躍するグローバル企業『不二工機』。既存設備への後付けも可能なため、導入のハードルが低く、多くの施設で採用されています。',
    content: '<br><br><a href="/book_towa2603a_all/book/" target="_blank" class="center parts-buttom01__anchor hover-fade" style="margin: auto;"><span class="parts-buttom01__text">商品パンフレット</span><span class="parts-buttom01__arw"><svg viewBox="0 0 10.41421 10"><g><g><line class="cls-1" x1="1" y1="5" x2="9" y2="5"></line><polyline class="cls-1" points="5 1 9 5 5 9"></polyline></g></g></svg></span></a><br>',
      features: [
        "省エネ効果（消費電力の低減・CO2削減）",
        "温度上昇による高圧カット防止",
        "室外機コンデンサを腐食させません！",
        "本来の冷却能力を発揮",
        "コンデンサの目詰まり予防のフィルター効果",
        "ヒートアイランド対策効果"
      ]
    },
    {
      name: "ホットブラインデフロストクーラー（マキシス工業）",
      image: "p-img-02.png",
      description: '加温したブライン液を専用回路に流して除霜する効率の良いデフロストシステムを搭載したユニットクーラーです。マキシス工業独自のパイプ配列により、コンパクトな設計を実現しました。<br>少ない熱量をポンプにて循環しデフロストを行いますので、省エネ性能に優れており、庫内への熱放出を大幅に削減するため、庫内温度の上昇を抑制します。物流倉庫など、24時間安定した温度管理が求められる現場に最適なソリューションです。',
    content: '<br><br><a href="/wp-content/uploads/2026/03/HotBrineDefrost.pdf" target="_blank" class="center parts-buttom01__anchor hover-fade" style="margin: auto;"><span class="parts-buttom01__text">商品パンフレット</span><span class="parts-buttom01__arw"><svg viewBox="0 0 10.41421 10"><g><g><line class="cls-1" x1="1" y1="5" x2="9" y2="5"></line><polyline class="cls-1" points="5 1 9 5 5 9"></polyline></g></g></svg></span></a><br>',
      features: [
        "低温デフロストで熱ロスを抑制、高い省エネ性を実現",
        "デフロスト時の庫内へのモヤ発生を大幅にカット",
        "ブライン昇温時に排熱を利用することにより、さらに消費電力を削減",
      "フィンと配管の密着構造により、除霜効率が向上",
        "シンプルなシステム構成で、安定した除霜が可能"
      ]
    },
  ];

export function initSwiper() {
  const el = document.querySelector('.kv-swiper');
  if (!el) return;

  new Swiper(el, {
    modules: [Autoplay, EffectFade],

    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,

    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },

    autoplay: {
      delay: 4000, // 切り替え間隔
      disableOnInteraction: false
    },

    speed: 1000, // フェード時間

    allowTouchMove: false, // ユーザー操作禁止
    simulateTouch: false
  });
}

export function ProductSwiper() {
  const el = document.querySelector('.product-swiper');
  if (!el) return;

  const next = el.parentElement.querySelector('.swiper-button-wrapper .next');
  const prev = el.parentElement.querySelector('.swiper-button-wrapper .prev');

  const pagination = el.parentElement.querySelector('.product-pagination-wrap .pagination');

  // console.log(next, prev);

  const swiper = new Swiper(el, {
    modules: [Navigation, Pagination],
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    // centeredSlidesBounds: true,
            slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        autoHeight: true,

    // Navigation arrows
    navigation: {
      nextEl: next,
      prevEl: prev,
    },

    // If we need pagination
    pagination: {
      el: pagination,
      clickable: true,
      dynamicBullets: true
    },

    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      768: {
        slidesPerView: 1.5,
      }
    },
    on: {
      afterInit(swiper) {
        setTimeout(() => {
          swiper.update();
          swiper.updateAutoHeight();
        }, 100);
      },
      slideChange(swiper) {
        requestAnimationFrame(() => {
          swiper.updateAutoHeight(300);
        });
      },
      resize(swiper) {
        swiper.update();
        swiper.updateAutoHeight();
      }
    }

    // And if we need scrollbar
    // scrollbar: {
    //   el: '.product-swiper-scrollbar',
    // },
  });

  const observer = new ResizeObserver(() => {
    swiper.updateAutoHeight();
  });
  
  swiper.slides.forEach(slide => {
    observer.observe(slide);
  });

  window.addEventListener('load', () => {
    swiper.update();
    swiper.updateAutoHeight();
  });

}

export function FlowSwiper() {
  const el = document.querySelector('.flow-swiper');
  if (!el) return;

  const pagination = el.parentElement.querySelector('.flow-pagination-wrap .pagination');
  // console.log(pagination);

  new Swiper(el, {
    modules: [Navigation, Pagination],
    // Optional parameters
    // direction: 'vertical',
    loop: false,
    slidesPerView: 1,
    // slidesPerView: 3,
    spaceBetween: 20,
    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    // },

    // Navigation arrows
    navigation: {
      nextEl: '.flow-next',
      prevEl: '.flow-prev',
    },

    pagination: {
      el: pagination,
      clickable: true,
      dynamicBullets: false
    },

    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      768: {
        slidesPerView: 3,
      }
    }
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  });
}

const waveView = async () => {
  const el = document.getElementById("waveCanvas");
  el.style.opacity = 1;
}

export function initWave() {

  let parent;

  const sketch = (p) => {

    let t = 0;
    let canvas;
    

    p.setup = () => {
      canvas = p.createCanvas(window.innerWidth, window.innerHeight);
      parent = canvas.parent("waveCanvas"); // HTML側の設置場所
      p.clear(); // 背景透過
    };

    p.draw = () => {

      p.clear();

      const color = "#80cdf1";

      // ===== 太いウェーブ =====
      p.stroke(color);
      p.strokeWeight(5);
      p.noFill();

      p.beginShape();

      for (let x = 0; x <= p.width; x += 20) {

        const y =
          p.height / 2 +
          Math.sin(x * 0.003 + t) * 180;

        p.vertex(x, y);
      }

      p.endShape();


      // ===== 細いウェーブ =====
      p.stroke(color);
      p.strokeWeight(2);

      p.beginShape();

      for (let x = 0; x <= p.width; x += 20) {

        const y =
          p.height / 2.3 +
          60 +
          Math.sin(x * 0.002 + t * 1.3) * 160;

        p.vertex(x, y);
      }

      p.endShape();

      t += 0.006;
    };


    // リサイズ対応
    p.windowResized = () => {
      p.resizeCanvas(window.innerWidth, window.innerHeight);
    };

  };

  new p5(sketch);
  waveView();
}

export function initTextReveal() {

  const rows = document.querySelectorAll(".reveal");

  rows.forEach((row, i) => {

    const mask = row.querySelector(".reveal-mask");
    const text = row.querySelector(".reveal-text");

    const tl = gsap.timeline({
      delay: i * 0.15
    });

    tl.fromTo(
      mask,
      { width: "0%" },
      {
        width: "100%",
        duration: 1,
        ease: "power3.out"
      }
    )
    .fromTo(
      text,
      { x: -20, opacity: 1 },
      {
        x: 0,
        opacity: 1,
        duration: 0.8,
        ease: "power3.out"
      },
      "-=1.0"
    );

  });

}

const kvImgView = async () => {
  const imgs = document.querySelectorAll(".img-anm");
  imgs.forEach((img, i) => {

    const tl = gsap.timeline({
      delay: i * 0.15
    });

    tl.fromTo(
      img,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 1,
        ease: "power3.out"
      }
    );
  });

};

export function spServiceTgl() {
const items = document.querySelectorAll(".service-item");

items.forEach((item, index) => {
  const header = item.querySelector(".service-header");
  const body = item.querySelector(".service-body");

  // 初期状態：閉じる
  gsap.set(body, { height: 0, overflow: "hidden" });

  let isOpen = false;

  header.addEventListener("click", () => {
    if (!isOpen) {
      // 開く
      gsap.to(body, {
        height: body.scrollHeight,
        duration: 0.4,
        ease: "power2.out"
      });
    } else {
      // 閉じる
      gsap.to(body, {
        height: 0,
        duration: 0.3,
        ease: "power2.in"
      });
    }

    isOpen = !isOpen;

    // クラス付け替え（ここ追加）
    item.classList.toggle("is-open", isOpen);
  });
  
  if (index == 0) {
    const header = item.querySelector(".service-header");
    const body = item.querySelector(".service-body");
  
    // 初期状態：閉じる
    gsap.set(body, { height: 0, overflow: "hidden" });
  
    let isOpen = false;
  
      if (!isOpen) {
        // 開く
        gsap.to(body, {
          height: body.scrollHeight,
          duration: 0.4,
          ease: "power2.out"
        });
      } else {
        // 閉じる
        gsap.to(body, {
          height: 0,
          duration: 0.3,
          ease: "power2.in"
        });
      }
  
      isOpen = !isOpen;
  
      // クラス付け替え（ここ追加）
      item.classList.toggle("is-open", isOpen);
  }
});
}

document.addEventListener('DOMContentLoaded', async() => {
  const images = document.body.querySelectorAll('img');
  

  Promise.all(
    [...images].map(img => {
      if (img.complete) return Promise.resolve();
      return new Promise(resolve => {
        img.onload = resolve;
        img.onerror = resolve;
      });
    })
  ).then(async() => {
    // initSwiper();
    // await initWave();
    // initTextReveal();
    // await kvImgView();
    await ProductSwiper();
    await FlowSwiper();
    await spServiceTgl();
  });

  /**
   * modal
   */
  const modalWrapper = document.querySelector('.modal-wrapper');


  // const els = document.querySelectorAll(".product-box");
  // els.forEach(el=>{
  //   el.addEventListener("click",()=>{
  //     const id = el.dataset.modal
  //     document.getElementById(id).classList.add("open")
  //     enableBlurBody();
  //   })
  // })

  // const elspk = document.querySelectorAll(".product-item");
  // elspk.forEach(el=>{
  //   el.addEventListener("click",()=>{
  //     const id = el.dataset.modal
  //     document.getElementById(id).classList.add("open")
  //     enableBlurBody();
  //   })
  // })


  const createProductModal = (item, id, type = 'product') => {
    const modal = document.createElement('div');
    modal.className = 'modal';
    modal.id = id;
  
    const imgPath = `${imgs}${item.image}`;
  
    const listTemplate = (arr = []) =>
      arr.map(text => `<li>${text}</li>`).join('');
  
    const isPickup = type === 'pickup';
  
    modal.innerHTML = `
      <div class="modal-inner">
        <button class="closeBtn" aria-label="閉じる"></button>
  
        <h3 class="no-br">${item.name}</h3>
  
        ${
          item.image
            ? `<img src="${imgPath}" alt="${item.name}" loading="lazy">`
            : ''
        }
  
        <h4>説明</h4>
  
        <p>
          ${item.description || ''}
          ${isPickup ? (item.content || '') : ''}
        </p>
  
        ${
          isPickup
            ? `
              <hr>
              <h4>特徴</h4>
              <ul>
                ${listTemplate(item.features)}
              </ul>
            `
            : `
              <hr>
              <h4>製品例</h4>
              <ul>
                ${listTemplate(item.examples)}
              </ul>
  
              <hr>
  
              <h4>主要取引先</h4>
              <ul>
                ${listTemplate(item.partners)}
              </ul>
            `
        }
      </div>
    `;
  
    // 閉じる
    const closeBtn = modal.querySelector('.closeBtn');
  
    closeBtn.addEventListener('click', () => {
      closeModal(modal);
    });
  
    // 背景クリックで閉じる
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal(modal);
      }
    });
  
    return modal;
  };
  
  
  const openModal = (data, index, type = 'product') => {
    const modalId =
      type === 'pickup'
        ? `modal-pick-${index}`
        : `modal-${index}`;
  
    // 念のためクリア（iframe強制破棄）
    modalWrapper.innerHTML = '';
  
    const modal = createProductModal(
      data,
      modalId,
      type
    );
  
    modalWrapper.appendChild(modal);
  
    requestAnimationFrame(() => {
      modal.classList.add('open');
    });
  
    enableBlurBody();
  };
  
  
  const closeModal = (modal) => {
    modal.classList.remove('open');
  
    disableBlurBody();
  
    // transition待ち
    setTimeout(() => {
      modalWrapper.innerHTML = '';
    }, 300);
  };  



  /**
   * product modal
   */
  document.querySelectorAll('.product-box')
    .forEach((el, i) => {
      el.addEventListener('click', () => {
        openModal(products[i], i, 'product');
      });
    });


  /**
   * pickup modal
   */
  document.querySelectorAll('.product-item')
    .forEach((el, i) => {
      el.addEventListener('click', () => {
        openModal(pickups[i], i, 'pickup');
      });
    });



    await removeSiteLoading();
});